<template>
  <div class="item-of-vouchers__wrapper mb-3" :class="isPointer ? 'cursor-pointer' : ''">
    <div
      class="ws-textbox ws-textbox__custom d-flex justify-content-between align-items-center hd-service-background-color"
      :class="{ disabled: disable || used || (taxi && !isFirstTripCompleted), 'ws-textbox__border': border }"
      :style="{ '--background-color': color }"
    >
      <div class="item-of-vouchers__icon-and-name d-flex align-items-center">
        <span class="item-of-vouchers__icon d-flex justify-content-center align-items-center">
          <img :src="`${$publicPath}images/icon-voucher/${icon}.png`" alt="" srcset="" class="img-voucher" />
        </span>
        <span class="item-of-vouchers__name mx-2 hd-item-title-color text-dark">
          <span v-if="disable && !used" class="text-cancelled"> Cancelled </span>
          <span v-if="used" class="font-weight-bold"> {{ lang['homepage_new']['SFS_LANG_ROW_29'] ?? 'Used' }} </span>
          {{ !disable || !used ? label : label.toLowerCase() }}
          <span v-if="number" class="item-of-vouchers__noti"> ({{ number }}) </span>
        </span>
      </div>
      <div v-if="pnr" class="item-of-vouchers__pnr hd-item-title-color">PNR: {{ pnr }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemOfVouchers',
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    pnr: {
      type: String,
      default: ''
    },
    number: {
      type: Number,
      default: 0
    },
    disable: {
      type: Boolean,
      default: false
    },
    used: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    url: {
      type: Object,
      default: () => {}
    },
    isHandleClick: {
      type: Boolean,
      default: false
    },
    taxi: {
      type: Boolean,
      default: false
    },
    isFirstTripCompleted: {
      type: Boolean,
      default: false
    },
    isPointer: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    isHandleClick() {
      if (this.isHandleClick && Object.keys(this.url).length) {
        this.$router.push({ path: this.url.path, query: this.url.query })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$height-icon: 70px;
.item-of-vouchers {
  &__wrapper {
    .ws-textbox__custom {
      height: 84%;
      padding: 0;
      box-shadow: 0px 2px 10px #33333319;
    }
    .ws-textbox__border {
      border: 1px solid var(--background-color);
      box-shadow: var(--background-color) 0px 1px 3px 0px;
    }

    .text-cancelled {
      font-weight: 500;
    }

    .img-voucher {
      width: 35px;
      height: 35px;
    }
    .hd-item-title-color {
      color: #474747;
    }
  }

  &__icon {
    width: 45px;
    height: 90%;
    padding: 0.85rem 0rem;
    border-radius: var(--voucher-icon-border-radius);
    background-color: var(--background-color);
  }

  &__pnr {
    padding-inline: 1rem;
  }
}

::v-deep .disabled {
  opacity: 0.7;
}

.cursor-pointer {
  cursor: pointer;
}
.hd-service-background-color {
  background-color: #fff;
  .hd-item-title-color {
    color: #474747;
  }
}
</style>
